const LAST_USED_SIGNIN_METHOD_KEY = 'logto:last_used_signin_method';

export const setLastUsedSigninMethod = (method: string) => {
  try {
    localStorage.setItem(LAST_USED_SIGNIN_METHOD_KEY, method);
  } catch {
    // localStorage not available (e.g. Android WebView with domStorageEnabled=false)
  }
};

export const getLastUsedSigninMethod = () => {
  try {
    return localStorage.getItem(LAST_USED_SIGNIN_METHOD_KEY);
  } catch {
    // localStorage not available (e.g. Android WebView with domStorageEnabled=false)
    return null;
  }
};